import DriversCards from "../../components/driverComponent/driversCards/driversCards";
import OverallSummary from "../../components/overallSummary/overallSummary";
import DriversSummary from "../../components/driverComponent/driversSummary/driversSummary";
import AllDrivers from "../../components/driverComponent/allDrivers/allDrivers";
import {useState} from "react";

import {driversSummary} from "../../data/driversData";
import CalendarType from "../../shared/calendarType/calendarType";
import DateRangePicker from "../../shared/dateRangePicker/dateRangePicker";

const Drivers = () => {
    const [summary] = useState(driversSummary);

    return (
        <>
            <div className={'content-section page-fade-in'}>
                <div className=" round-corner-8 padding-tb-20 flex hr-right border-bottom margin-b-30">
                    <DateRangePicker selectRange={true} classes={'date width-300 item-height-40'}/>
                    <CalendarType/>
                </div>

                {/*..... card dashboard .....*/}
                <div className="margin-b-50"><DriversCards/></div>

                {/*..... overall summary .....*/}
                {/*<div className="margin-b-50"><OverallSummary/></div>*/}
            </div>
            <div className=" margin-b-50">
                <div className={'content-section'}>
                    {/*..... drivers overall summary .....*/}
                    <div className=""><DriversSummary summary={summary}/></div>
                </div>
            </div>
            <div className="">
                <div className={'content-section'}>
                    {/*..... All drivers .....*/}
                    <div className=""><AllDrivers/></div>
                </div>
            </div>
        </>
    )
}

export default Drivers;
